<template>
  <div class="px-2" style="width: 100%">
    <div
      v-if="!$store.state.logged.status"
      :style="{
        width: '100%',
        height: '300px',
        backgroundImage: gameData
          ? `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
          url(https://cdn.softswiss.net/b/${
            gameData.identifier_game.split(':')[0]
          }/${gameData.identifier_game.split(':')[1]}.jpg)`
          : '',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'start',
        borderRadius: '16px',
      }"
    >
      <div
        class="d-flex flex-column align-center my-8"
        style="gap: 12px"
        v-if="gameData"
      >
        <v-img
          v-if="imageError === false"
          :src="gameData.src"
          eager
          max-width="25%"
          @error="imageError = true"
          style="
                border-radius: 2rem;
              "
        >
          <template v-slot:placeholder>
            <div class="d-flex align-center justify-center fill-height">
              <v-progress-circular
                color="grey-lighten-4"
                indeterminate
              ></v-progress-circular>
            </div>
          </template>
        </v-img>

        <div
          v-html="
            $t('newCasino.unloggedAtGame', {
              game: gameData && gameData.title_game,
            })
          "
          class="text-body-1 text-center mx-7"
        ></div>
        <div class="d-flex align-center">
          <DialogRegister idDialog="mobileGame" />
          <Login />
        </div>
      </div>
    </div>

    <div v-else-if="$store.state.logged.status" id="game_wrapper"></div>
    <!-- Footer Game -->
    <div
      v-if="$store.state.logged.status"
      class="d-flex flex-column colorDominant"
      style="border-radius: 1rem"
    >
      <!-- Image Game -->
      <div
        style="min-height: 160px;
        overflow: hidden"
      >
        <v-skeleton-loader
          v-show="imageError === false && loadingImage && !gameErrorSession"
          type="image"
          height="181"
          style="border-radius: 1rem 1rem 0 0"
        ></v-skeleton-loader>

        <v-img
          v-if="imageError === false && !gameErrorSession"
          :src="imageGame"
          eager
          style="background-size: contain; border-radius: 1rem 1rem 0 0"
          @error="imageError = true"
          @load="loadingImage = false"
          @click="fetchGame"
        ></v-img>
        <div
          v-if="gameErrorSession"
          class="errors-container"
          :style="{
            width: '100%',
            height: '200px',
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${gameData.src})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }"
        >
          <div class="d-flex flex-column mt-3 align-center">
            <div class="BorderMobile">
              <SvgIcon svgId="errorGameMobile" />
              <h6 class="error-messages">
                {{ $t("gameNotAvailable") }}
                {{ $t("pleaseTryAgainLater") }}
              </h6>
            </div>
          </div>
        </div>
        <div
          v-if="imageError === true"
          class="d-flex justify-center imageErrorIcon"
          :alt="gameDataStore && gameDataStore.title_game"
          style="min-height: 160px; max-height: 150px"
        >
          <v-icon color="primary">mdi-poker-chip</v-icon>
        </div>
      </div>

      <div class="d-flex align-center pa-4">
        <!-- Image Game -->
        <img
          v-if="$vuetify.breakpoint.width > 350 &&
            gameDataStore &&
            gameDataStore.src
          "
          class="mr-4"
          width="50px"
          :src="gameDataStore.src"
          style="border-radius: 1rem;"
        />

        <!-- Game name / Provider name -->
        <div
          :style="
            $vuetify.breakpoint.width < 350 && {
              maxWidth: '210px',
            } ||
            $vuetify.breakpoint.width < 450 && {
              maxWidth: '140px',
            }
          "
        >
          <v-skeleton-loader
            v-if="!gameDataStore && loading"
            width="150px"
            type="text"
          ></v-skeleton-loader>
          <h5
            v-else
            class="text-truncate"
            style="font-size: 1.2rem; line-height: 1.1rem; margin-bottom: 7px;"
          >
            <v-btn icon @click="handleGameFavorite(gameDataStore)">
              <v-icon size="24">{{ btnFavoriteConfig.icon }}</v-icon>
            </v-btn>
            {{ gameDataStore && gameDataStore.title_game }}
          </h5>
          <v-skeleton-loader
            v-if="!gameDataStore && loading"
            width="75px"
            type="text"
          ></v-skeleton-loader>
          <h6
            v-else
            class="text-truncate"
            style="
              max-width: 25ch;
              color: #ccc;
              font-weight: 400;
              font-size: 0.9rem;
              text-transform: capitalize;
            "
          >
            {{ gameDataStore && gameDataStore.name_provider }}
          </h6>
        </div>

        <!-- Button Play -->
        <div class="ml-auto">
          <v-btn
            color="primary"
            v-show="!gameErrorSession"
            fab
            :loading="loading"
            @click="fetchGame"
          >
            <v-icon>mdi-play</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SvgIcon from "../SvgIcon.vue";
import Login from "@/components/login/dialog.vue";
import DialogRegister from "@/views/home/register/dialog-register";
import {
  isGameFavorite,
  addGameFavorite,
  removeGameFavorite
} from "@/util/casino/gameFavorite.js";

export default {
  name: "MobileGame",
  components: {
    SvgIcon,
    Login,
    DialogRegister,
  },
  props: ["loading", "gameUrl", "gameData", "status"],
  data: () => ({
    loadingImage: true,
    imageError: false,
    gameDataStore: {},
    btnFavoriteConfig: { icon: "" },
  }),

  mounted() {
    this.setCurrentGame();
    // this.fetchCurrentGameData();
    this.updateBtnFavoriteConfig();
  },

  watch: {
    // Caso que o usuário entrou na view sem fazer o listByOperator
    gameData() {
      this.setCurrentGame();
    },
    "$route.params.gameId"() {
      this.setCurrentGame();
    },
    gamesFavoritesUpdating() {
      this.updateBtnFavoriteConfig();
    },
  },

  computed: {
    gameErrorSession() {
      return this.status === 400;
    },
    imageGame() {
      if (this.gameDataStore && this.gameDataStore.identifier_game) {
        const identifier = this.gameDataStore.identifier_game;
        const [game, provider] = identifier.split(":");
        return `https://cdn.softswiss.net/i/s2/${game}/${provider}.png`;
      }
      return "";
    },
    casinoType() {
      return this.$route.params.casinoType;
    },
    gamesFavoritesUpdating() {
      return this.$store.state.gamesFavoritesUpdating;
    },
  },

  methods: {
    setCurrentGame() {
      if (this.gameData != undefined) {
        this.$store.commit("setCasinoCurrentGameMobile", this.gameData);
        this.gameDataStore = this.gameData;
      } else {
        this.gameDataStore = this.$store.state.casinoCurrentGameMobile;
      }
    },
    fetchCurrentGameData() {
      this.$axios
        .post(
          "/player/online/casino/game",
          this.$formdata({
            game_id: this.$route.params.gameId,
          })
        )
        .then((res) => {
          this.gameData = res.data.dados;
          this.gameData.providerImage = encodeURI(
            `https://cdn.softswiss.net/logos/providers/white/${res.data.dados.provider}.svg`.replace(
              /\s/g,
              ""
            )
          );
        });
    },
    fetchGame() {
      // Criar Session do game e redirecionar o usuário
      this.$emit("fetchGame");
    },
    updateBtnFavoriteConfig() {
      const btnConfig = {
        0: { icon: "mdi-star-outline" },
        1: { icon: "mdi-star-check" },
      };

      this.btnFavoriteConfig =
        btnConfig[isGameFavorite(this.casinoType, this.gameDataStore.key)];
    },
    handleGameFavorite(game) {
      if (isGameFavorite(this.casinoType, game.key)) {
        removeGameFavorite(this.casinoType, game.key);
      } else {
        addGameFavorite(this.casinoType, game);
      }
    },
  },
};
</script>

<style>
.v-skeleton-loader__image {
  height: 100% !important;
}

#game_wrapper {
  width: 100%;
}

#game_wrapper iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.error-messages {
  color: #ccc;
  font-weight: 400;
  font-size: 12px;
  font-family: Roboto;
  text-align: center;
  margin-bottom: 15px;
  width: 75%;
}

.errors-container {
  border-radius: 16px 16px 0px 0px;
  padding-bottom: 16px;
}

.BorderMobile {
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid rgb(255, 255, 255, 0.3);
  border-radius: 18px;
  width: 90%;
}
</style>
